// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { getAdminPing, getAuthMe, getAuthSignin, getAuthSigninByOrganisasjonsNummerRouteParam, getAuthSignout, getAvtalePerioder, getAvtalePrivat, getAvtaler, getAvtalerForLeverandørCsv, getAvtalerSummaryForLeverandør, getAvtaleSelskap, getGrunnlagForPeriode, getInnrapporteringsFrister, getInnrapporteringsFristerForPeriode, getInnstillinger, getKundeportalVarslerGlobal, getMalerdataPerioder, getOppgjørForPeriode, getOrganisasjonerForUser, getSearchAvtaler, getSelskaper, getSelskapsportalUserSelskaper, getSelskapsportalVarslerGlobal, type Options, postAvbestillAvtale, postAvtalePrivat, postAvtaleSelskap, postInnrapporteringSimulate, postInnrapporteringUpload, postInnrapporteringValidate, postInnstillinger, postUgyldigAvtale, putAvtalePrivat, putAvtaleSelskap } from '../sdk.gen';
import type { GetAdminPingData, GetAuthMeData, GetAuthMeResponse, GetAuthSigninByOrganisasjonsNummerRouteParamData, GetAuthSigninByOrganisasjonsNummerRouteParamError, GetAuthSigninData, GetAuthSignoutData, GetAvtalePerioderData, GetAvtalePerioderResponse2, GetAvtalePrivatData, GetAvtalePrivatResponse2, GetAvtalerData, GetAvtalerError, GetAvtalerForLeverandørCsvData, GetAvtalerForLeverandørCsvError, GetAvtalerResponse2, GetAvtalerSummaryForLeverandørData, GetAvtalerSummaryForLeverandørError, GetAvtalerSummaryForLeverandørResponse2, GetAvtaleSelskapData, GetAvtaleSelskapError, GetAvtaleSelskapResponse2, GetGrunnlagForPeriodeData, GetGrunnlagForPeriodeError, GetInnrapporteringsFristerData, GetInnrapporteringsFristerForPeriodeData, GetInnrapporteringsFristerForPeriodeResponse, GetInnrapporteringsFristerResponse2, GetInnstillingerData, GetInnstillingerError, GetInnstillingerResponse2, GetKundeportalVarslerGlobalData, GetKundeportalVarslerGlobalResponse, GetMalerdataPerioderData, GetMalerdataPerioderResponse2, GetOppgjørForPeriodeData, GetOppgjørForPeriodeError, GetOppgjørForPeriodeResponse, GetOrganisasjonerForUserData, GetOrganisasjonerForUserResponse, GetSearchAvtalerData, GetSearchAvtalerResponse2, GetSelskaperData, GetSelskaperError, GetSelskaperResponse2, GetSelskapsportalUserSelskaperData, GetSelskapsportalUserSelskaperResponse, GetSelskapsportalVarslerGlobalData, GetSelskapsportalVarslerGlobalResponse, PostAvbestillAvtaleData, PostAvbestillAvtaleError, PostAvbestillAvtaleResponse, PostAvtalePrivatData, PostAvtalePrivatError, PostAvtalePrivatResponse2, PostAvtaleSelskapData, PostAvtaleSelskapError, PostAvtaleSelskapResponse2, PostInnrapporteringSimulateData, PostInnrapporteringSimulateError, PostInnrapporteringSimulateResponse, PostInnrapporteringUploadData, PostInnrapporteringUploadError, PostInnrapporteringValidateData, PostInnrapporteringValidateError, PostInnrapporteringValidateResponse, PostInnstillingerData, PostInnstillingerError, PostInnstillingerResponse2, PostUgyldigAvtaleData, PostUgyldigAvtaleError, PutAvtalePrivatData, PutAvtalePrivatError, PutAvtalePrivatResponse2, PutAvtaleSelskapData, PutAvtaleSelskapError, PutAvtaleSelskapResponse2 } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getAuthSigninByOrganisasjonsNummerRouteParamQueryKey = (options: Options<GetAuthSigninByOrganisasjonsNummerRouteParamData>) => createQueryKey('getAuthSigninByOrganisasjonsNummerRouteParam', options);

export const getAuthSigninByOrganisasjonsNummerRouteParamOptions = (options: Options<GetAuthSigninByOrganisasjonsNummerRouteParamData>) => queryOptions<unknown, AxiosError<GetAuthSigninByOrganisasjonsNummerRouteParamError>, unknown, ReturnType<typeof getAuthSigninByOrganisasjonsNummerRouteParamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuthSigninByOrganisasjonsNummerRouteParam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthSigninByOrganisasjonsNummerRouteParamQueryKey(options)
});

export const getAuthSigninQueryKey = (options?: Options<GetAuthSigninData>) => createQueryKey('getAuthSignin', options);

export const getAuthSigninOptions = (options?: Options<GetAuthSigninData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getAuthSigninQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuthSignin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthSigninQueryKey(options)
});

export const getAuthSignoutQueryKey = (options?: Options<GetAuthSignoutData>) => createQueryKey('getAuthSignout', options);

export const getAuthSignoutOptions = (options?: Options<GetAuthSignoutData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getAuthSignoutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuthSignout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthSignoutQueryKey(options)
});

export const getAuthMeQueryKey = (options?: Options<GetAuthMeData>) => createQueryKey('getAuthMe', options);

export const getAuthMeOptions = (options?: Options<GetAuthMeData>) => queryOptions<GetAuthMeResponse, AxiosError<DefaultError>, GetAuthMeResponse, ReturnType<typeof getAuthMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuthMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthMeQueryKey(options)
});

export const postAvtalePrivatMutation = (options?: Partial<Options<PostAvtalePrivatData>>): UseMutationOptions<PostAvtalePrivatResponse2, AxiosError<PostAvtalePrivatError>, Options<PostAvtalePrivatData>> => {
    const mutationOptions: UseMutationOptions<PostAvtalePrivatResponse2, AxiosError<PostAvtalePrivatError>, Options<PostAvtalePrivatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAvtalePrivat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postAvtaleSelskapMutation = (options?: Partial<Options<PostAvtaleSelskapData>>): UseMutationOptions<PostAvtaleSelskapResponse2, AxiosError<PostAvtaleSelskapError>, Options<PostAvtaleSelskapData>> => {
    const mutationOptions: UseMutationOptions<PostAvtaleSelskapResponse2, AxiosError<PostAvtaleSelskapError>, Options<PostAvtaleSelskapData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAvtaleSelskap({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postAvbestillAvtaleMutation = (options?: Partial<Options<PostAvbestillAvtaleData>>): UseMutationOptions<PostAvbestillAvtaleResponse, AxiosError<PostAvbestillAvtaleError>, Options<PostAvbestillAvtaleData>> => {
    const mutationOptions: UseMutationOptions<PostAvbestillAvtaleResponse, AxiosError<PostAvbestillAvtaleError>, Options<PostAvbestillAvtaleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAvbestillAvtale({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAvtalerQueryKey = (options?: Options<GetAvtalerData>) => createQueryKey('getAvtaler', options);

export const getAvtalerOptions = (options?: Options<GetAvtalerData>) => queryOptions<GetAvtalerResponse2, AxiosError<GetAvtalerError>, GetAvtalerResponse2, ReturnType<typeof getAvtalerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAvtaler({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAvtalerQueryKey(options)
});

export const getAvtalePrivatQueryKey = (options: Options<GetAvtalePrivatData>) => createQueryKey('getAvtalePrivat', options);

export const getAvtalePrivatOptions = (options: Options<GetAvtalePrivatData>) => queryOptions<GetAvtalePrivatResponse2, AxiosError<DefaultError>, GetAvtalePrivatResponse2, ReturnType<typeof getAvtalePrivatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAvtalePrivat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAvtalePrivatQueryKey(options)
});

export const putAvtalePrivatMutation = (options?: Partial<Options<PutAvtalePrivatData>>): UseMutationOptions<PutAvtalePrivatResponse2, AxiosError<PutAvtalePrivatError>, Options<PutAvtalePrivatData>> => {
    const mutationOptions: UseMutationOptions<PutAvtalePrivatResponse2, AxiosError<PutAvtalePrivatError>, Options<PutAvtalePrivatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putAvtalePrivat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAvtaleSelskapQueryKey = (options: Options<GetAvtaleSelskapData>) => createQueryKey('getAvtaleSelskap', options);

export const getAvtaleSelskapOptions = (options: Options<GetAvtaleSelskapData>) => queryOptions<GetAvtaleSelskapResponse2, AxiosError<GetAvtaleSelskapError>, GetAvtaleSelskapResponse2, ReturnType<typeof getAvtaleSelskapQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAvtaleSelskap({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAvtaleSelskapQueryKey(options)
});

export const putAvtaleSelskapMutation = (options?: Partial<Options<PutAvtaleSelskapData>>): UseMutationOptions<PutAvtaleSelskapResponse2, AxiosError<PutAvtaleSelskapError>, Options<PutAvtaleSelskapData>> => {
    const mutationOptions: UseMutationOptions<PutAvtaleSelskapResponse2, AxiosError<PutAvtaleSelskapError>, Options<PutAvtaleSelskapData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putAvtaleSelskap({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAvtalePerioderQueryKey = (options?: Options<GetAvtalePerioderData>) => createQueryKey('getAvtalePerioder', options);

export const getAvtalePerioderOptions = (options?: Options<GetAvtalePerioderData>) => queryOptions<GetAvtalePerioderResponse2, AxiosError<DefaultError>, GetAvtalePerioderResponse2, ReturnType<typeof getAvtalePerioderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAvtalePerioder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAvtalePerioderQueryKey(options)
});

export const getSelskaperQueryKey = (options?: Options<GetSelskaperData>) => createQueryKey('getSelskaper', options);

export const getSelskaperOptions = (options?: Options<GetSelskaperData>) => queryOptions<GetSelskaperResponse2, AxiosError<GetSelskaperError>, GetSelskaperResponse2, ReturnType<typeof getSelskaperQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSelskaper({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSelskaperQueryKey(options)
});

export const getOrganisasjonerForUserQueryKey = (options?: Options<GetOrganisasjonerForUserData>) => createQueryKey('getOrganisasjonerForUser', options);

export const getOrganisasjonerForUserOptions = (options?: Options<GetOrganisasjonerForUserData>) => queryOptions<GetOrganisasjonerForUserResponse, AxiosError<DefaultError>, GetOrganisasjonerForUserResponse, ReturnType<typeof getOrganisasjonerForUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganisasjonerForUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganisasjonerForUserQueryKey(options)
});

export const getKundeportalVarslerGlobalQueryKey = (options?: Options<GetKundeportalVarslerGlobalData>) => createQueryKey('getKundeportalVarslerGlobal', options);

export const getKundeportalVarslerGlobalOptions = (options?: Options<GetKundeportalVarslerGlobalData>) => queryOptions<GetKundeportalVarslerGlobalResponse, AxiosError<DefaultError>, GetKundeportalVarslerGlobalResponse, ReturnType<typeof getKundeportalVarslerGlobalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getKundeportalVarslerGlobal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getKundeportalVarslerGlobalQueryKey(options)
});

export const getSelskapsportalUserSelskaperQueryKey = (options?: Options<GetSelskapsportalUserSelskaperData>) => createQueryKey('getSelskapsportalUserSelskaper', options);

export const getSelskapsportalUserSelskaperOptions = (options?: Options<GetSelskapsportalUserSelskaperData>) => queryOptions<GetSelskapsportalUserSelskaperResponse, AxiosError<DefaultError>, GetSelskapsportalUserSelskaperResponse, ReturnType<typeof getSelskapsportalUserSelskaperQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSelskapsportalUserSelskaper({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSelskapsportalUserSelskaperQueryKey(options)
});

export const postInnrapporteringUploadMutation = (options?: Partial<Options<PostInnrapporteringUploadData>>): UseMutationOptions<unknown, AxiosError<PostInnrapporteringUploadError>, Options<PostInnrapporteringUploadData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInnrapporteringUploadError>, Options<PostInnrapporteringUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInnrapporteringUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMalerdataPerioderQueryKey = (options: Options<GetMalerdataPerioderData>) => createQueryKey('getMalerdataPerioder', options);

export const getMalerdataPerioderOptions = (options: Options<GetMalerdataPerioderData>) => queryOptions<GetMalerdataPerioderResponse2, AxiosError<DefaultError>, GetMalerdataPerioderResponse2, ReturnType<typeof getMalerdataPerioderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMalerdataPerioder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMalerdataPerioderQueryKey(options)
});

export const getOppgjørForPeriodeQueryKey = (options: Options<GetOppgjørForPeriodeData>) => createQueryKey('getOppgjørForPeriode', options);

export const getOppgjørForPeriodeOptions = (options: Options<GetOppgjørForPeriodeData>) => queryOptions<GetOppgjørForPeriodeResponse, AxiosError<GetOppgjørForPeriodeError>, GetOppgjørForPeriodeResponse, ReturnType<typeof getOppgjørForPeriodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOppgjørForPeriode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOppgjørForPeriodeQueryKey(options)
});

export const getGrunnlagForPeriodeQueryKey = (options: Options<GetGrunnlagForPeriodeData>) => createQueryKey('getGrunnlagForPeriode', options);

export const getGrunnlagForPeriodeOptions = (options: Options<GetGrunnlagForPeriodeData>) => queryOptions<unknown, AxiosError<GetGrunnlagForPeriodeError>, unknown, ReturnType<typeof getGrunnlagForPeriodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGrunnlagForPeriode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGrunnlagForPeriodeQueryKey(options)
});

export const postInnrapporteringValidateMutation = (options?: Partial<Options<PostInnrapporteringValidateData>>): UseMutationOptions<PostInnrapporteringValidateResponse, AxiosError<PostInnrapporteringValidateError>, Options<PostInnrapporteringValidateData>> => {
    const mutationOptions: UseMutationOptions<PostInnrapporteringValidateResponse, AxiosError<PostInnrapporteringValidateError>, Options<PostInnrapporteringValidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInnrapporteringValidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postInnrapporteringSimulateMutation = (options?: Partial<Options<PostInnrapporteringSimulateData>>): UseMutationOptions<PostInnrapporteringSimulateResponse, AxiosError<PostInnrapporteringSimulateError>, Options<PostInnrapporteringSimulateData>> => {
    const mutationOptions: UseMutationOptions<PostInnrapporteringSimulateResponse, AxiosError<PostInnrapporteringSimulateError>, Options<PostInnrapporteringSimulateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInnrapporteringSimulate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInnrapporteringsFristerQueryKey = (options?: Options<GetInnrapporteringsFristerData>) => createQueryKey('getInnrapporteringsFrister', options);

export const getInnrapporteringsFristerOptions = (options?: Options<GetInnrapporteringsFristerData>) => queryOptions<GetInnrapporteringsFristerResponse2, AxiosError<DefaultError>, GetInnrapporteringsFristerResponse2, ReturnType<typeof getInnrapporteringsFristerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInnrapporteringsFrister({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInnrapporteringsFristerQueryKey(options)
});

export const getInnrapporteringsFristerForPeriodeQueryKey = (options: Options<GetInnrapporteringsFristerForPeriodeData>) => createQueryKey('getInnrapporteringsFristerForPeriode', options);

export const getInnrapporteringsFristerForPeriodeOptions = (options: Options<GetInnrapporteringsFristerForPeriodeData>) => queryOptions<GetInnrapporteringsFristerForPeriodeResponse, AxiosError<DefaultError>, GetInnrapporteringsFristerForPeriodeResponse, ReturnType<typeof getInnrapporteringsFristerForPeriodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInnrapporteringsFristerForPeriode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInnrapporteringsFristerForPeriodeQueryKey(options)
});

export const getAvtalerForLeverandørCsvQueryKey = (options: Options<GetAvtalerForLeverandørCsvData>) => createQueryKey('getAvtalerForLeverandørCsv', options);

export const getAvtalerForLeverandørCsvOptions = (options: Options<GetAvtalerForLeverandørCsvData>) => queryOptions<unknown, AxiosError<GetAvtalerForLeverandørCsvError>, unknown, ReturnType<typeof getAvtalerForLeverandørCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAvtalerForLeverandørCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAvtalerForLeverandørCsvQueryKey(options)
});

export const getAvtalerSummaryForLeverandørQueryKey = (options: Options<GetAvtalerSummaryForLeverandørData>) => createQueryKey('getAvtalerSummaryForLeverandør', options);

export const getAvtalerSummaryForLeverandørOptions = (options: Options<GetAvtalerSummaryForLeverandørData>) => queryOptions<GetAvtalerSummaryForLeverandørResponse2, AxiosError<GetAvtalerSummaryForLeverandørError>, GetAvtalerSummaryForLeverandørResponse2, ReturnType<typeof getAvtalerSummaryForLeverandørQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAvtalerSummaryForLeverandør({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAvtalerSummaryForLeverandørQueryKey(options)
});

export const getSearchAvtalerQueryKey = (options: Options<GetSearchAvtalerData>) => createQueryKey('getSearchAvtaler', options);

export const getSearchAvtalerOptions = (options: Options<GetSearchAvtalerData>) => queryOptions<GetSearchAvtalerResponse2, AxiosError<DefaultError>, GetSearchAvtalerResponse2, ReturnType<typeof getSearchAvtalerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSearchAvtaler({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSearchAvtalerQueryKey(options)
});

export const postUgyldigAvtaleMutation = (options?: Partial<Options<PostUgyldigAvtaleData>>): UseMutationOptions<unknown, AxiosError<PostUgyldigAvtaleError>, Options<PostUgyldigAvtaleData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostUgyldigAvtaleError>, Options<PostUgyldigAvtaleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postUgyldigAvtale({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInnstillingerQueryKey = (options: Options<GetInnstillingerData>) => createQueryKey('getInnstillinger', options);

export const getInnstillingerOptions = (options: Options<GetInnstillingerData>) => queryOptions<GetInnstillingerResponse2, AxiosError<GetInnstillingerError>, GetInnstillingerResponse2, ReturnType<typeof getInnstillingerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInnstillinger({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInnstillingerQueryKey(options)
});

export const postInnstillingerMutation = (options?: Partial<Options<PostInnstillingerData>>): UseMutationOptions<PostInnstillingerResponse2, AxiosError<PostInnstillingerError>, Options<PostInnstillingerData>> => {
    const mutationOptions: UseMutationOptions<PostInnstillingerResponse2, AxiosError<PostInnstillingerError>, Options<PostInnstillingerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInnstillinger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSelskapsportalVarslerGlobalQueryKey = (options?: Options<GetSelskapsportalVarslerGlobalData>) => createQueryKey('getSelskapsportalVarslerGlobal', options);

export const getSelskapsportalVarslerGlobalOptions = (options?: Options<GetSelskapsportalVarslerGlobalData>) => queryOptions<GetSelskapsportalVarslerGlobalResponse, AxiosError<DefaultError>, GetSelskapsportalVarslerGlobalResponse, ReturnType<typeof getSelskapsportalVarslerGlobalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSelskapsportalVarslerGlobal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSelskapsportalVarslerGlobalQueryKey(options)
});

export const getAdminPingQueryKey = (options?: Options<GetAdminPingData>) => createQueryKey('getAdminPing', options);

export const getAdminPingOptions = (options?: Options<GetAdminPingData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getAdminPingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAdminPing({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminPingQueryKey(options)
});
